/* import __COLOCATED_TEMPLATE__ from './vertical-radio-button-group.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import templateOnly from '@ember/component/template-only';
const PulseCandidateVerticalRadioButtonGroupComponent = templateOnly();
export default PulseCandidateVerticalRadioButtonGroupComponent;